import { MediaStreamKind, Slot, SlotType } from '@yandex-video-platform/goloom-sdk';
import cn from 'classnames';

import css from '../styles.css';

export const getSlotsClassNames = ({ slots, videoStatus }: { slots: Slot[]; videoStatus: boolean }) => {
    return slots.map((slot) => {
        if (slot.type === SlotType.SELF_VIEW) {
            return cn(css.selfView, {
                [css.itemDevices]: videoStatus,
            });
        }

        return cn({
            [css.itemDisplay]: slot.mediaStreamKind === MediaStreamKind.DISPLAY,
            [css.itemDevices]: slot.mediaStreamKind === MediaStreamKind.DEVICES,
        });
    });
};
